import React, { useEffect, useState } from "react";
import moment from "moment";
import Modal from "react-modal";
import { RxCross2 } from "react-icons/rx";
import india from "../../../images/ind.png";
import { indianNumberFormat } from "../../../utils/handlers";

import { MdKeyboardArrowDown, MdKeyboardArrowRight } from "react-icons/md";
const customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0,80%)",
    zIndex: "100",
    overflow: "scroll",
  },
};
const Insurance = ({ vehicleDetails }) => {
  const token = sessionStorage.getItem("token");
  const [hideChallan, setHideChallan] = useState(true);
  const [offense, setOffense] = useState(false);

  const [openEdit, setOpenEdit] = useState(false);
  const [category, setCategory] = useState("insurance");
  const [isChecked, setIsChecked] = useState("Pending");
  const [underlineChallan, setUnderlineChallan] = useState(false);
  const [activeChallan, setActiveChallan] = useState(0);

  const validDate = (item) => {
    let currentDate = moment(new Date()).format("L");
    let insuranceDate = moment(item, "DD/MM/YYYY").format("L");
    let currentYear = new Date(currentDate).getFullYear();
    let insuranceYear = new Date(insuranceDate).getFullYear();
    if (Number(insuranceYear) < Number(currentYear)) {
      return "Expired";
    } else if (Number(insuranceYear) === Number(currentYear)) {
      var diff = moment(currentDate).diff(insuranceDate);
      const diffDays = Math.floor(diff / (1000 * 60 * 60 * 24));
      if (Math.sign(diffDays) === 1) {
        return "Expired";
      } else if (Math.sign(diffDays) === -1) {
        return "Active";
      } else {
        return "Active";
      }
    } else {
      return "Active";
    }
  };
  return (
    <>
      <p className=" font-bold text-[22px] text-[#262626]">
        Insurance & Challan
      </p>
      <div className=" px-4 pb-4 mt-4 max-w-[400px]  rounded-lg border border-[#e6ebed]">
        {vehicleDetails && vehicleDetails.insurance_details !== null && (
          <div
            className="flex flex-row justify-between items-center bg-white  hover:bg-[#e6ebed] py-3 px-4 rounded-lg cursor-pointer"
            style={{
              marginBottom: "24px",
              marginTop: "16px",
            }}
            onClick={() => {
              setOpenEdit(!openEdit);
              setCategory("insurance");
            }}
          >
            <div
              className="flex flex-col justify-start items-start gap-3"
              style={{ flexBasis: "40%" }}
            >
              <h5 className="text-sm font-bold text-[#262626]">Insurance</h5>
              <p
                className={`text-xs font-medium rounded-xl h-[23px] pl-2 pr-2 pt-1 pb-1 text-center ${
                  validDate(vehicleDetails?.insurance_details?.validTill) ===
                  "Expired"
                    ? "text-[#d30d00] bg-[#f6dedd]"
                    : "text-[#0ba300] bg-[#dbe8db]"
                }`}
              >
                {validDate(vehicleDetails?.insurance_details?.validTill)}
              </p>
            </div>
            <div className="flex flex-col justify-start items-start gap-3">
              <p className="font-medium text-xs text-[#848484]">Valid till</p>
              <h5 className="text-[#262626] text-sm font-bold">
                {moment(
                  vehicleDetails?.insurance_details?.validTill,
                  "DD/MM/YYYY"
                ).format("ll")}
              </h5>
            </div>
            <div className="flex flex-col justify-start items-start gap-3">
              <MdKeyboardArrowRight
                size={25}
                color="#262626"
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
        )}
        {vehicleDetails && vehicleDetails.challan_details !== null ? (
          <div
            className="flex flex-row justify-between items-center  bg-white hover:bg-[#e6ebed]  py-3 px-4 rounded-lg cursor-pointer"
            onClick={() => {
              setOpenEdit(!openEdit);
              setCategory("challans");
            }}
          >
            <div
              className="flex flex-col justify-start items-start gap-3"
              style={{ flexBasis: "40%" }}
            >
              <h5 className="text-[#262626] text-sm font-bold">Challan</h5>
              {vehicleDetails?.challan_details?.filter(
                (i) => i.challan_status === "Pending"
              ).length > 0 ? (
                <p className="text-xs font-medium text-[#d30d00] bg-[#f6dedd] rounded-xl h-[23px] pl-2 pr-2 pb-1 pt-1 text-center">
                  Active Challan
                </p>
              ) : (
                <p className="text-xs font-medium text-[#0ba300] bg-[#dbe8db] rounded-xl h-[23px] pl-2 pr-2 pb-1 pt-1 text-center">
                  No Active Challan
                </p>
              )}
            </div>
            <div className="flex flex-col justify-start items-start gap-3">
              <p className="font-medium text-xs text-[#848484]">
                No. of Challan
              </p>
              <h5 className="text-[#262626] text-sm font-bold">
                {
                  vehicleDetails?.challan_details?.filter(
                    (item) => item.challan_status === "Pending"
                  ).length
                }
              </h5>
            </div>
            <div className="flex flex-col justify-start items-start gap-3">
              <MdKeyboardArrowRight
                size={25}
                color="#262626"
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
        ) : (
          <div
            className="flex flex-row justify-between items-center  bg-white hover:bg-[#e6ebed] py-3 px-4 rounded-lg cursor-pointer"
            onClick={() => {
              setOpenEdit(!openEdit);
              setCategory("challans");
            }}
          >
            <div
              className="flex flex-col justify-start items-start gap-3"
              style={{ flexBasis: "40%" }}
            >
              <h5 className="text-[#262626] text-sm font-bold">Challan</h5>
              <p className="text-xs font-medium text-[#0ba300] bg-[#dbe8db] rounded-xl h-[23px] pl-2 pr-2 pb-1 pt-1 text-center">
                No Active Challan
              </p>
            </div>
            <div className="flex flex-col justify-start items-start gap-3">
              <p className="font-medium text-xs text-[#848484]">
                No. of Challan
              </p>
              <h5 className="text-[#262626] text-sm font-bold">0</h5>
            </div>
            <div className="flex flex-col justify-start items-start gap-3">
              <MdKeyboardArrowRight
                size={25}
                color="#262626"
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
        )}

        <Modal
          isOpen={openEdit}
          style={customStyles}
          preventScroll={false}
          className={`absolute flex justify-center items-center inset-0 m-auto outline-0`}
        >
          <div className="bg-white p-6 rounded-xl w-[494px]">
            <div className="flex flex-row justify-between items-center ">
              <h5
                className="text-[#262626] text-base font-bold text-end capitalize
"
              >
                {category}
              </h5>
              <RxCross2
                size={20}
                color="#262626"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setOpenEdit(!openEdit);
                  setIsChecked("Pending");
                }}
              />
            </div>
            <div
              className="flex flex-row justify-between items-center"
              style={{ marginTop: "28px" }}
            >
              <div className="bg-[#262626] pl-2 pr-2 pt-[2px] pb-[2px] flex flex-row justify-center items-center rounded-sm">
                <img
                  src={india}
                  alt="india"
                  className="w-[13px] h-[13px] mr-[10px]"
                />
                <p className="text-sm font-medium text-white">
                  {vehicleDetails?.vehicle_number}
                </p>
              </div>
              <h5 className="text-[#262626] text-sm font-bold text-end">
                {vehicleDetails?.model_name}
              </h5>
            </div>
            <div
              className="flex flex-row justify-between items-center"
              style={{ marginTop: "12px" }}
            >
              <div
                className="flex flex-col justify-start"
                style={{ textAlign: "end" }}
              >
                <p className="text-xs font-medium text-[#848484] mb-[6px]">
                  Owner Name:
                </p>
                <h5 className="text-[#262626] text-sm font-bold text-end">
                  {vehicleDetails?.owner_name}
                </h5>
              </div>
              <div className="flex flex-col justify-start">
                <p className="text-xs font-medium text-[#848484] mb-[6px]">
                  Current Value:
                </p>
                <h5 className="text-[#47b971] text-[14px] font-bold text-right">
                  &#8377;{" "}
                  {vehicleDetails?.current_price
                    ? indianNumberFormat(vehicleDetails?.current_price)
                    : "---"}
                </h5>
              </div>
            </div>

            <div className="my-4 h-[1px] w-full border border-solid border-[#a6a6a6]"></div>
            {category === "insurance" ? (
              <>
                <div className="flex flex-row justify-start items-start">
                  <img
                    src={india}
                    alt="company"
                    className="w-[50px] h-[50px] rounded-[3px]"
                  />
                  <div className="flex flex-col justify-start items-start gap-2 ml-[15px]">
                    <h5 className="text-[#262626] text-sm font-bold">
                      {vehicleDetails?.insurance_details?.company}
                    </h5>
                    <p
                      className={`text-xs font-medium rounded-xl h-[23px] pl-2 pr-2 pb-1 pt-1 text-center ${
                        validDate(
                          vehicleDetails?.insurance_details?.validTill
                        ) === "Expired"
                          ? "text-[#d30d00] bg-[#f6dedd]"
                          : "text-[#0ba300] bg-[#dbe8db]"
                      }`}
                    >
                      {validDate(vehicleDetails?.insurance_details?.validTill)}
                    </p>
                  </div>
                </div>
                <div
                  className="flex flex-row justify-between items-center"
                  style={{ marginTop: "12px" }}
                >
                  <div className="flex flex-col justify-start">
                    <p className="text-xs font-medium text-[#848484] mb-[6px]">
                      Insurance Policy No.
                    </p>
                    <h5 className="text-xs font-semibold text-[#262626]">
                      {vehicleDetails?.insurance_details?.policyNumber}
                    </h5>
                  </div>
                  <div
                    className="flex flex-col justify-start"
                    style={{ textAlign: "end" }}
                  >
                    <p className="text-xs font-medium text-[#848484] mb-[6px]">
                      Insurance Upto
                    </p>
                    <h5 className="text-xs font-semibold text-[#262626]">
                      {vehicleDetails?.insurance_details?.validTill}
                    </h5>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <label className="relative inline-flex cursor-pointer select-none items-center justify-center rounded bg-[#f3f3f3] p-1">
                    <span
                      className={`t text-xs ext-[#262626] ${
                        isChecked === "Pending"
                          ? "flex items-center rounded py-1 px-3  font-semibold bg-white"
                          : "flex items-center rounded py-1 px-3 font-semibold bg-[#f3f3f3] "
                      }`}
                      onClick={() => {
                        setIsChecked("Pending");
                        setActiveChallan(0);
                      }}
                    >
                      Pending Challans{" "}
                      {`(${
                        vehicleDetails &&
                        vehicleDetails?.challan_details !== null
                          ? vehicleDetails?.challan_details?.filter(
                              (item) => item.challan_status === "Pending"
                            ).length
                          : 0
                      })`}
                    </span>
                    <span
                      className={` text-xs text-[#262626] ${
                        isChecked === "Disposed"
                          ? "flex items-center rounded py-1 px-3  font-semibold bg-white"
                          : "flex items-center rounded py-1 px-3  font-semibold bg-[#f3f3f3]"
                      }`}
                      onClick={() => {
                        setIsChecked("Disposed");
                        setActiveChallan(0);
                      }}
                    >
                      Disposed Challans{" "}
                      {`(${
                        vehicleDetails &&
                        vehicleDetails?.challan_details !== null
                          ? vehicleDetails?.challan_details?.filter(
                              (item) => item.challan_status === "Disposed"
                            ).length
                          : 0
                      })`}
                    </span>
                  </label>
                </div>
                <div className="mt-6 w-full max-w-full">
                  <ul
                    className={`${
                      vehicleDetails &&
                      vehicleDetails?.challan_details !== null &&
                      vehicleDetails?.challan_details.length > 0 &&
                      vehicleDetails?.challan_details.filter(
                        (i) => i.challan_status === isChecked
                      ).length > 3
                        ? "justify-between "
                        : "justify-start gap-6"
                    } flex items-center flex-wrap text-sm font-medium text-white list-none`}
                  >
                    {vehicleDetails &&
                    vehicleDetails?.challan_details !== null &&
                    vehicleDetails?.challan_details.length > 0 &&
                    vehicleDetails?.challan_details.filter(
                      (i) => i.challan_status === isChecked
                    ).length > 0 ? (
                      vehicleDetails.challan_details
                        .filter((i) => i.challan_status === isChecked)
                        .map((item, index) => {
                          if (index > 2) {
                            return null;
                          } else {
                            return (
                              <li className="me-2" key={index}>
                                <p
                                  className={`${
                                    index === activeChallan
                                      ? "text-[#00394d] rounded-t underline text-xs font-bold"
                                      : "text-[#444444] no-underline text-xs font-medium"
                                  } cursor-pointer`}
                                  onClick={() => {
                                    setActiveChallan(index);
                                    setUnderlineChallan(false);
                                  }}
                                >
                                  Challan: {index + 1}
                                </p>
                              </li>
                            );
                          }
                        })
                    ) : (
                      <></>
                    )}
                    {vehicleDetails &&
                    vehicleDetails?.challan_details !== null &&
                    vehicleDetails?.challan_details?.length > 0 &&
                    vehicleDetails?.challan_details?.filter(
                      (i) => i.challan_status === isChecked
                    ).length > 0 ? (
                      <li
                        // style={{
                        //   display: "flex",
                        //   justifyContent: "center",
                        //   alignItems: "flex-end",
                        //   cursor: "pointer",
                        //   position: "relative",
                        //   gap: "10px",
                        // }}
                        className="flex justify-center items-center cursor-pointer relative gap-[10px] p-1"
                        onClick={() => setHideChallan(!hideChallan)}
                      >
                        {vehicleDetails?.challan_details?.filter(
                          (i) => i.challan_status === isChecked
                        ).length > 3 && (
                          <>
                            <span
                              className={`${
                                underlineChallan
                                  ? "underline decoration-[1.5px] decoration-[#00394d] text-[#262626]"
                                  : "decoration-[1.5px] decoration-[#00394d] text-[#262626]"
                              } text-end`}
                            >
                              more
                            </span>
                            <MdKeyboardArrowDown
                              size={25}
                              color="#262626"
                              className={`${
                                hideChallan
                                  ? "bg-[#e6ebed] cursor-pointer mt-[5px]"
                                  : "bg-[#e6ebed] cursor-pointer mt-[5px]"
                              }`}
                            />
                          </>
                        )}
                        <div
                          id="dropdown"
                          class={`${
                            hideChallan
                              ? "w-[120px] absolute top-6 bottom-0 -left-[30px] right-0 z-10 mt-2 origin-top-right rounded-[5px] bg-white shadow-lg block overflow-auto"
                              : "absolute bottom-0 left-0 right-0 top-5 z-10 mt-2 w-[154px] h-[140px] origin-top-right rounded-[5px] bg-white shadow-lg hidden"
                          }`}
                          style={{
                            height:
                              hideChallan &&
                              vehicleDetails &&
                              vehicleDetails?.challan_details?.length > 5
                                ? "110px"
                                : "fit-content",
                          }}
                        >
                          <ul className="pt-2 pb-2 text-sm font-medium list-none">
                            {vehicleDetails.challan_details
                              .filter((i) => i.challan_status === isChecked)
                              .map((item, index) => {
                                if (index <= 2) {
                                  return null;
                                } else {
                                  return (
                                    <li
                                      key={index}
                                      className={`${
                                        index === activeChallan
                                          ? "w-full cursor-pointer bg-[#e6ebed]"
                                          : "w-full cursor-pointer bg-white hover:bg-[#BDBDBD]"
                                      }`}
                                      onClick={() => {
                                        setActiveChallan(index);
                                        setUnderlineChallan(true);
                                      }}
                                    >
                                      <span className="block py-2 px-4 no-underline text-xs font-medium text-center text-[#262626]">
                                        Challan: {index + 1}
                                      </span>
                                    </li>
                                  );
                                }
                              })}
                          </ul>
                        </div>
                      </li>
                    ) : (
                      <></>
                    )}
                  </ul>
                </div>
                {vehicleDetails &&
                vehicleDetails?.challan_details !== null &&
                vehicleDetails?.challan_details?.length > 0 &&
                vehicleDetails?.challan_details?.filter(
                  (i) => i.challan_status === isChecked
                ).length > 0 ? (
                  <>
                    <div
                      className="flex flex-row justify-between items-center"
                      style={{ marginTop: "16px" }}
                    >
                      <div className="flex flex-col justify-start">
                        <h5 className="text-[#262626] text-sm font-bold text-end">
                          Challan:
                          {
                            vehicleDetails?.challan_details.filter(
                              (i) => i.challan_status === isChecked
                            )[activeChallan]?.number
                          }{" "}
                          (
                          {
                            vehicleDetails?.challan_details.filter(
                              (i) => i.challan_status === isChecked
                            )[activeChallan]?.challan_number
                          }
                          )
                        </h5>
                      </div>
                    </div>
                    <div
                      className="flex flex-row justify-between items-center"
                      style={{ marginTop: "16px" }}
                    >
                      <div className="flex flex-col justify-start">
                        <p className="text-xs font-medium text-[#848484] mb-[6px]">
                          Status
                        </p>
                        <p className="text-xs font-medium text-[#859000] bg-[#e7ebb7] rounded-xl h-[23px] pl-2 pr-2 pt-1 pb-1 text-center">
                          {
                            vehicleDetails?.challan_details.filter(
                              (i) => i.challan_status === isChecked
                            )[activeChallan]?.challan_status
                          }
                        </p>
                      </div>
                      <div
                        className="flex flex-col justify-start"
                        style={{ textAlign: "end" }}
                      >
                        <p className="text-xs font-medium text-[#848484] mb-[6px]">
                          Amount
                        </p>
                        <h5 className="text-xs font-semibold text-[#262626]">
                          &#8377;{" "}
                          {
                            vehicleDetails?.challan_details.filter(
                              (i) => i.challan_status === isChecked
                            )[activeChallan]?.amount
                          }
                        </h5>
                      </div>
                    </div>
                    <div
                      className="flex flex-row justify-between items-center"
                      style={{ marginTop: "24px" }}
                    >
                      <div className="flex flex-col justify-start">
                        <p className="text-xs font-medium text-[#848484] mb-[6px]">
                          Challan Date
                        </p>
                        <h5 className="text-xs font-semibold text-[#262626]">
                          {
                            vehicleDetails?.challan_details.filter(
                              (i) => i.challan_status === isChecked
                            )[activeChallan]?.challan_date
                          }
                        </h5>
                      </div>
                      <div
                        className="flex flex-col justify-start"
                        style={{ textAlign: "end" }}
                      >
                        <p className="text-xs font-medium text-[#848484] mb-[6px]">
                          Court Challan
                        </p>
                        <h5 className="text-xs font-semibold text-[#262626]">
                          {vehicleDetails?.challan_details.filter(
                            (i) => i.challan_status === isChecked
                          )[activeChallan]?.court_challan === false
                            ? "No"
                            : "Yes"}
                        </h5>
                      </div>
                    </div>
                    <div
                      className="flex flex-row justify-between items-center"
                      style={{ marginTop: "24px", alignItems: "flex-start" }}
                    >
                      <div
                        className="flex flex-col justify-start"
                        style={{ flexBasis: "50%" }}
                      >
                        <p className="text-xs font-medium text-[#848484] mb-[6px]">
                          Offence Details
                        </p>
                        <h5 className="text-xs font-semibold text-[#262626]">
                          {offense
                            ? vehicleDetails?.challan_details.filter(
                                (i) => i.challan_status === isChecked
                              )[activeChallan]?.offense_details
                            : vehicleDetails?.challan_details
                                .filter((i) => i.challan_status === isChecked)
                                [activeChallan]?.offense_details?.slice(0, 25) +
                              (vehicleDetails?.challan_details.filter(
                                (i) => i.challan_status === isChecked
                              )[activeChallan]?.offense_details.length > 25
                                ? "..."
                                : "")}
                          &nbsp;&nbsp;
                          {vehicleDetails?.challan_details.filter(
                            (i) => i.challan_status === isChecked
                          )[activeChallan]?.offense_details?.length > 25 && (
                            <span
                              style={{
                                backgroundColor: "#F3F3F3",
                                cursor: "pointer",
                                padding: 2,
                              }}
                              onClick={() => setOffense(!offense)}
                            >
                              {offense ? "less" : "more"}
                            </span>
                          )}
                        </h5>
                      </div>
                      <div
                        className="flex flex-col justify-start"
                        style={{ textAlign: "end" }}
                      >
                        <p className="text-xs font-medium text-[#848484] mb-[6px]">
                          Accused Name
                        </p>
                        <h5 className="text-xs font-semibold text-[#262626]">
                          {
                            vehicleDetails?.challan_details.filter(
                              (i) => i.challan_status === isChecked
                            )[activeChallan]?.accused_name
                          }
                        </h5>
                      </div>
                    </div>
                    <div
                      className="flex flex-row justify-between items-center"
                      style={{ marginTop: "24px" }}
                    >
                      <div className="flex flex-col justify-start">
                        <p className="text-xs font-medium text-[#848484] mb-[6px]">
                          Challan Number
                        </p>
                        <h5 className="text-xs font-semibold text-[#262626]">
                          {
                            vehicleDetails?.challan_details.filter(
                              (i) => i.challan_status === isChecked
                            )[activeChallan]?.challan_number
                          }
                        </h5>
                      </div>
                      <div
                        className="flex flex-col justify-start"
                        style={{ textAlign: "end" }}
                      >
                        <p className="text-xs font-medium text-[#848484] mb-[6px]">
                          State
                        </p>
                        <h5 className="text-xs font-semibold text-[#262626]">
                          {
                            vehicleDetails?.challan_details.filter(
                              (i) => i.challan_status === isChecked
                            )[activeChallan]?.state
                          }
                        </h5>
                      </div>
                    </div>
                  </>
                ) : (
                  <p className="text-sm font-bold text-red-700 text-center">
                    No Data to show
                  </p>
                )}
              </>
            )}
          </div>
        </Modal>
      </div>
    </>
  );
};

export default Insurance;
